<template>

  <div id="app_content" class="public" :class="{loading: loading}">

    <div class="section std bgi">

      <div class="section-container">


        <div v-if="isMounted" class="texture">

          <div class="content">

              <div class="content-init">
                  <link-page-back :page="'family'" :meta="getFamilyCode"/>
                  <!-- header info -->
                  <div class="w-section">
                    <section class="header">
                      <div class="w-image">
                        <image-elm :elm="getFirstArt"/>
                      </div>
                      <div class="w-text">
                        <!-- <div class="fcgreen"><h1 class="m-0">{{ getCodeGroup }}</h1></div> -->
                        <div class="fcgreen"><h1 class="mt-0"><cod-elm :elm="getFirstArt"/></h1></div>
                        <div class="desc-group ttc">{{ getDescGroup.toLowerCase() }}</div>
                        <div class="name-category ttc">{{ getCategoryLevel.toLowerCase()  }}</div>
                      </div>
                    </section>
                  </div>

                  <!-- general datasheet -->
                  <div v-if="generalDatasheet && generalDatasheet.length > 0" class="w-section general-datasheet">

                    <h3 class="mt-0 uc ttl">{{trans.get('generals.datasheet')}}</h3>
                    <div class="content">

                      <div v-for="scheda_tecnica in generalDatasheet" :key="scheda_tecnica.id" class="row">
                        <span>{{scheda_tecnica.etichetta.descrizione}}</span>
                        <span>{{scheda_tecnica.contenuto}}</span>
                      </div>
                    </div>
                  </div>

                  <!-- articles list -->
                  <div class="w-section articles-list">

                    <h3 class="mt-0 ttl">{{trans.get('generals.articles_list')}}</h3>

                    <section>

                      <div class="w-table">

                        <table>
                          <tr class="head">
                            <td class="ttl">{{trans.get('generals.article')}}</td>
                            <td v-for="scheda_tecnica in specificDatasheet" :key="scheda_tecnica.id">{{scheda_tecnica.etichetta.descrizione}}</td>
                            <td class="td-pdf"> PDF </td>
                          </tr>
                          <tr v-for="(art, i) in articles" :key="i">
                            <td class="codart-val fcgreen">{{art.cod_art}}</td>
                            <td v-for="scheda_tecnica in articleSpecificDatasheet(art)" :key="scheda_tecnica.id">{{scheda_tecnica.contenuto}}</td>
                            <td class="td-pdf ttl">
                              <a class="fcblue download-pdf" v-if="linkDownloadPdf(art)" :href="linkDownloadPdf(art)" download target="_blank">{{trans.get('generals.download')}}</a>
                              <span v-else>--</span>
                            </td>
                          </tr>
                        </table>

                      </div>

                      <!-- <b-table :mobile-cards="false" :data="data" :columns="columns"></b-table> -->

                    </section>

                  </div>

              </div>

            </div>

          </div>
          <!-- .texture -->

        </div>
        <!-- .section-container -->




      </div>


    </div>
</template>

<script>

// import { Table, Input } from 'buefy'
// import 'buefy/dist/buefy.css'

export default{

  components: { },

  data: function(){

    return {


        loading: false,
        isMounted: false,
        group_family: null,
        articles: [],


    }

  },

  created: function() {


  },

  mounted: function() {

    this.loadFamilyGroup();
  },

  computed: {

    getFirstArt: function() {
      if ( this.articles.length )
        return this.articles[0];
      else
        return null;
    },

    getFamilyCode: function() {
      let o = this.getFirstArt;
      if (!o) return '';
      return o.cod_famiglia;
    },

    getCodeGroup: function() {
      let o = this.getFirstArt;
      if (!o) return '';

      let str_name = '';

      str_name = o.cod_art.replace(/[\d]/g, '').replace('  ', ' ');


      return str_name.trim();
    },

    getDescGroup: function() {
      let o = this.getFirstArt;
      if (!o) return '';

      let str_name = '';
      if(o.family)
        str_name += ' ' + o.family.descrizione;

      if(o.color)
        str_name += ' ' + o.color.descrizione;

      return str_name.trim();
    },

    getCategoryLevel: function(){
      let o = this.getFirstArt;
      if (!o) return '';
      return (o.category) ? o.category.descrizione : null;
    },

    generalDatasheet: function(){

      if( !this.getFirstArt ){
        return null;
      } else{
        return _.filter( this.getFirstArt.datasheet, function(data){ return data.generale == 1; } );
      }

    },

    specificDatasheet(){

      if( !this.getFirstArt ){
        return null;
      } else{
        return _.filter( this.getFirstArt.datasheet, function(data){ return data.generale == 0; } );
      }

    }

  },

  methods: {

    linkDownloadPdf: function (article) {
      if ('annotazioni' in article && article.annotazioni.length > 0) {
        return this.url('/media/articles/pdf/' + article.annotazioni[0].id_allegato + '.pdf');
      } else {
        return null;
      }
    },

    articleSpecificDatasheet(article){

      return _.filter( article.datasheet, function(data){ return data.generale == 0; } );

    },

    loadFamilyGroup: function() {
      var vue = this;
      vue.loading = true;
      let pathname = window.location.pathname.split('/');
      let cod_family = pathname[pathname.length-2];

      //
      let _search = new URLSearchParams( window.location.search);
      let cod_color = _search.get('color');
      let cod_category = _search.get('category');

      axios({
        method: 'get',
        url: window.location.origin + '/data/get-group-family',
        params: {
          color: cod_color,
          category: cod_category,
          family: cod_family,
        }
      })
      .then(res => {

        if(res.data.group_family) vue.group_family = res.data.group_family;
        if(res.data.articles) vue.articles = res.data.articles;


        vue.isMounted = true;
      })
      .catch(err => {

        vue.loading = false;

        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        })

      })
    },

    lorem: function(p = 0) {
      let lorem = "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
      // let lastP = lorem.lastIndexOf('.');
      // return (p) ? lorem.slice(0, (p <= lastP) ? p : lastP ) : lorem;
      return lorem;
    },

    layoutText: function (v = 1){
      switch(v) {
        case 1:
          return "Be conservatively in the selections of the countries and the languages’ in which your AdWords ads are supposed to appear. If your product or your service turn only to customers speaking in a German manner, you should tune “Germany” and “Austria” as countries. With corresponding success you can try out also further countries, for example Switzerland, and areas close to the border. This method can also be applied to any other language.";
        break;

        case 2:
        default:
          return "Be conservatively in the selections of the countries and the languages’ in which your AdWords ads are supposed to appear. If your product or your service turn only to customers speaking in a German manner, you should";
        break;
      }
    }

  }

}
</script>

<style scoped>
body {
  height: 100%;
}
#app_content.public {
  height: 100%;
}

/*
 * contenuto delle sezioni allineato togliendo l'ingombro
 * del menù
*/
.section .section-container{
	max-width: calc(100% - var(--public-menu-width));
	margin: 0 0 0 var(--public-menu-width);
}

@media screen and (max-width: 1220px)
{
  .section .section-container {
    max-width: 95%;
    margin: auto;
  }
}

.section-container .texture {
  max-width: 1000px;
  margin: auto;
}

.section.bgi {
	width: 100%;
  height: auto;
  min-height: 100vh;
	color: white;
	background-repeat: no-repeat;
	background-origin: initial;
	background-clip: initial;
	background-size: contain;
	background-position: top;
  background-color: var(--black-2);
  padding: 82px 0 0 0;
}

.element {
	width: 250px;
	height: 150px;
	background: #000;
	color: #fff;
	margin: 10px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
}

.section .content .content-init {
  color: white;
  width: auto;
  /* max-width: 780px; */
  height: auto;
  margin: auto;

}
.w-section, .w-section section {
  width: 100%;
  height: auto;
}
.w-section section.header{
  display: flex;
}
.w-section section.header .w-image{
  width: 50%;
}
.w-section section.header .w-image img{
  width: 100%;
  height: auto;
  display: block;
}
.w-section section.header .w-text{
  width: 50%;
  padding-left: 20px;
}
.w-section section.header .w-text .name-category {
  font-weight: 300;
}
.w-section.articles-list,
.w-section.general-datasheet{
  margin-top: 4em;
}
.w-section.articles-list {
  padding-bottom: 4em;
}
.w-table {
  overflow-y: auto;
}
.w-table table {
  width: 100%;
  border-collapse: collapse;
}
.w-table th {
  font-weight: 300;
}
.w-table tr {
  margin: 0.5em 0;
  /* display: block; */
  background-color: rgba(255,255,255, 0.1);
}
.w-table tr.head {
  background-color: transparent;
}
.w-table td {
  padding: 1em;
  border: 12px solid var(--black-2);
  border-left: none;
  border-right: none;
  font-size: 0.8em;
  text-align: center;
}
.w-table tr.head td {
  font-size: 0.8em;
}

.w-table table tr td:first-child {
  padding: 1em 0 1em 1em;
  width: 80px;
  text-align: left;
}
.w-table table tr  td:last-child {
  padding: 1em 0 1em 1em;
}

.w-table .tr {
  margin: 1em 0;
  display: block;
  background-color: rgba(255,255,255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.w-table .head {
  font-weight: 300;
  background-color: transparent;
}
.w-table .td {
  width: 33%;
  padding: 1em 1em;
}
.general-datasheet{
  width: 100%;
}
.general-datasheet .content{
  width: 100%;
}
.general-datasheet .content .row{
  width: 100%;
  padding: 1em;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.general-datasheet .content .row:nth-child(odd){
  background-color: rgba(255,255,255, 0.1);
}
.general-datasheet .content .row span{
  width: 50%;
}
td.td-pdf {
  padding-right: 10px !important;
}
td.td-pdf a:hover {
  text-decoration: underline;
}
a.download-pdf {
  font-size: 1.1em;
}
</style>
